const s = {
  name: "Overview",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3c0,1.7,1.3,3,3,3s3-1.3,3-3C6,1.3,4.7,0,3,0z M2,3c0-0.6,0.4-1,1-1s1,0.4,1,1
			c0,0.6-0.4,1-1,1S2,3.6,2,3z"/>
		<path class="st0" d="M3,16c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C6,17.3,4.7,16,3,16z M2,19c0-0.6,0.4-1,1-1s1,0.4,1,1
			c0,0.6-0.4,1-1,1S2,19.6,2,19z"/>
		<path class="st0" d="M0,11c0-1.7,1.3-3,3-3s3,1.3,3,3c0,1.7-1.3,3-3,3S0,12.7,0,11z M3,10c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1
			s1-0.4,1-1C4,10.4,3.6,10,3,10z"/>
		<path class="st0" d="M3,32c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C6,33.3,4.7,32,3,32z M2,35c0-0.6,0.4-1,1-1s1,0.4,1,1
			s-0.4,1-1,1S2,35.6,2,35z"/>
		<path class="st0" d="M0,27c0-1.7,1.3-3,3-3s3,1.3,3,3c0,1.7-1.3,3-3,3S0,28.7,0,27z M3,26c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1
			s1-0.4,1-1C4,26.4,3.6,26,3,26z"/>
		<path class="st0" d="M8,28h32v-2H8V28z"/>
		<path class="st0" d="M40,20H8v-2h32V20z"/>
		<path class="st0" d="M8,12h32v-2H8V12z"/>
		<path class="st0" d="M40,4H8V2h32V4z"/>
		<path class="st0" d="M8,36h32v-2H8V36z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Overview
};
